module.exports = __webpack_public_path__ + "static/img/middle6.4d7ef3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/orgextension/middle6.jpg
// module id = AS0D
// module chunks = 9